import { render, staticRenderFns } from "./SiteCreationDialog.vue?vue&type=template&id=07b210b0&scoped=true"
import script from "./SiteCreationDialog.vue?vue&type=script&lang=js"
export * from "./SiteCreationDialog.vue?vue&type=script&lang=js"
import style0 from "./SiteCreationDialog.vue?vue&type=style&index=0&id=07b210b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b210b0",
  null
  
)

export default component.exports